import type { ApiFetch } from "../../types/api";
import type { EntraUser, InternalAccess, InternalUserAccess, InternalUserAccessInput } from "./types";

async function readJson<T>(response: Response): Promise<T> {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || "De aanvraag kon niet worden uitgevoerd.");
  return body as T;
}

export async function getInternalAccess(apiFetch: ApiFetch): Promise<InternalAccess> {
  const response = await apiFetch("/api/admin/internal-access/me");
  if (!response.ok) throw new Error(`API HTTP ${response.status}`);
  return readJson<InternalAccess>(response);
}

export async function listInternalUsers(apiFetch: ApiFetch): Promise<InternalUserAccess[]> {
  const body = await readJson<{ items: InternalUserAccess[] }>(await apiFetch("/api/admin/internal-access/users"));
  return body.items;
}

export async function searchEntraUsers(apiFetch: ApiFetch, query: string): Promise<EntraUser[]> {
  const body = await readJson<{ items: EntraUser[] }>(await apiFetch(`/api/admin/internal-access/entra-users/search?q=${encodeURIComponent(query)}`));
  return body.items;
}

export async function saveInternalUser(apiFetch: ApiFetch, userObjectId: string, input: InternalUserAccessInput): Promise<void> {
  await readJson(await apiFetch(`/api/admin/internal-access/users/${userObjectId}`, {
    method: "PUT",
    body: JSON.stringify(input),
  }));
}

export async function deleteInternalUser(apiFetch: ApiFetch, userObjectId: string): Promise<void> {
  await readJson(await apiFetch(`/api/admin/internal-access/users/${userObjectId}`, {
    method: "DELETE",
  }));
}
